export default __webpack_public_path__ + "static/media/createGame.0566639c.svg";